import { USERINFOKEY } from './../constants/index'
import { defineStore } from 'pinia'
import { getUserInfo, getAppConfig } from '@/api'
const useStore = defineStore(USERINFOKEY, {
  state: () => {
    return {
      userInfo: null,
      appConfig: null
    }
  },
  getters: {
    okrAdminUrl: () => {
      return `${location.origin}/admin/`
    },
    isCanPreviewOkr(state) {
      if (!state.userInfo) {
        return null
      } else {
        let appList = state.userInfo.appCodeList || []
        return appList.find((app) => {
          return app == 'okr'
        })
          ? true
          : false
      }
    },
    isCanPreviewPerf(state) {
      if (!state.userInfo) {
        return null
      } else {
        let appList = state.userInfo.appCodeList || []
        return appList.find((app) => app == 'perf') ? true : false
      }
    },
    isOkrAdmin: (state) => {
      if (!state.userInfo) {
        return false
      } else {
        return state.userInfo.isOkrAdmin
      }
    },
    isPerfAdmin: (state) => {
      if (!state.userInfo) {
        return false
      } else {
        return state.userInfo.isPerfAdmin
      }
    },
    okrHelpLink: (state) => {
      let { appConfig } = state
      if (!appConfig) {
        return null
      }
      let okrConfig = appConfig.find((item) => item.configCode == 'okr_product_book')
      if (!okrConfig) {
        return null
      }
      return okrConfig.configValue
    },
    officeName: (state) => state.userInfo?.officeName,
    avatar: (state) => state.userInfo?.pic,
    username: (state) => state.userInfo?.userName,
    userId: (state) => state.userInfo?.userId
  },
  actions: {
    updataUserInfo() {
      if (!this.appConfig) {
        getAppConfig().then((res) => {
          this.appConfig = res
        })
      }
      if (this.userInfo) {
        return Promise.resolve(this.userInfo)
      } else {
        return getUserInfo().then((res) => {
          this.userInfo = res
          return res
        })
      }
    }
  }
})
export default useStore
